import React from 'react';
import SVG from 'react-inlinesvg';
import { Redirect, Route } from 'react-router-dom';

import './index.css';
import Anetwork from '../../components/articles/anetwork';
import Sonder from '../../components/articles/sonder';
import goback from '../../images/article/back.svg';
import anetworkHeader from '../../images/article/anetwork-header.jpg';
import sonderHeader from '../../images/article/sonder-header.jpg';
import articlesList from '../../pages/blog/articles';

class Article extends React.Component {
  getArticleBackground = (article) => {
    switch (article) {
      case 'anetwork':
        return anetworkHeader
      case 'sonder':
        return sonderHeader
      default:
        return null;
    }
  }

  render() {
    let articleTitle = this.props.match.params.article;
    let isMatch = articlesList.some(article => article.title.toLowerCase() === articleTitle);
    if (isMatch) {
      return (
        <div className="articleContainer page">
          <div
            className="articleContainer__header"
            style={{
              backgroundImage: `url(${this.getArticleBackground(articleTitle)})`
            }}>
            <h1>{articleTitle}</h1>
            <span className="subtitle">{localStorage.getItem('lang') == 'ru'? 'Пишем об интересных проектах и решениях':'We write about interesting projects and solutions'}</span>
            <div className="articleContainer__header__footer">
              <div
                className="articleContainer__header__footer__back"
                onClick={() => this.props.history.push('/blog')}>
                <SVG src={goback} className="articleContainer__header__footer__back__icon" />
                <span className="articleContainer__header__footer__back__label">{localStorage.getItem('lang') == 'ru'? 'все статьи':'all articles'}</span>
              </div>
            </div>
          </div>
          <Route component={Anetwork} path="/blog/anetwork" />
          <Route component={Sonder} path="/blog/sonder" />
        </div>
      )
    } else {
      return <Redirect to="/blog" />
    }
  }
}

export default Article;


// WEBPACK FOOTER //
// ./src/pages/article/index.jsx